import { Divider, IconButton, List, ListHeading, ListItem } from 'omakase';
import { FunctionComponent, MouseEvent, useContext } from 'react';
import { IconClose } from 'ui/icons';
import { IconCrossLarge } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { PatronLocationEntity } from 'components/patron-location/PatronLocation';
import { PatronLocationStateContext } from 'components/patron-location/PatronLocationContext';

const LIST_TITLE = 'list-title';

interface PatronLocationFinderHistoryProps {
  activeLocation?: PatronLocationEntity;
  onResult(result: PatronLocationEntity): void;
}

export const PatronLocationFinderHistory: FunctionComponent<PatronLocationFinderHistoryProps> = ({
  activeLocation,
  onResult,
}) => {
  const { currentPatronLocationHistory, removePatronLocationFromHistory } = useContext(
    PatronLocationStateContext
  );

  const filteredHistory = currentPatronLocationHistory.filter(
    (result) => result.placeId !== activeLocation?.placeId
  );

  const handleRemoveItem = (e: MouseEvent<Element> | undefined, placeId: string) => {
    e?.stopPropagation();
    removePatronLocationFromHistory(placeId);
  };

  // Don't render the history portion (including the divider) is patron does not have location history
  if (!filteredHistory.length) {
    return null;
  }

  return (
    <>
      <Divider variant="thick" position="middle" tall />
      <List aria-labelledby={LIST_TITLE}>
        <ListHeading id={LIST_TITLE} size="medium">
          Recent locations
        </ListHeading>
        {filteredHistory.map((result) => {
          const { placeId, textPrimary, textSecondary } = result;
          return (
            <ListItem
              component="button"
              key={placeId}
              onClick={() => onResult(result)}
              size="large"
              weight="book"
              variant="basic"
              secondaryText={textSecondary}
              elementEndProps={{
                isInteractive: true,
                element: (
                  <IconButton
                    aria-label={`Remove "${textPrimary}" from history`}
                    size="small"
                    onClick={(e) => handleRemoveItem(e, placeId)}
                    variant="ghost"
                  >
                    <IconMigrationUtil legacyIcon={<IconClose />} newIcon={<IconCrossLarge />} />
                  </IconButton>
                ),
                interactiveElementSize: 36,
              }}
            >
              {textPrimary}
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
